<template>
  <div class="gseaHallmark">
    <a-row>
      <a-col :span="24">
        <a-spin :spinning="spinning" tip="Loading...">
          <vxe-toolbar>
            <template #buttons>
              <vxe-input
                v-model="filterName_detable"
                type="search"
                placeholder="Input a key word"
                @keyup="searchEvent_detable"
              ></vxe-input>
              <vxe-button @click="exportDataEvent"
                ><a-icon type="cloud-download" /> Download</vxe-button
              >
            </template>
          </vxe-toolbar>
          <vxe-table
            border
            show-overflow
            row-id="id"
            size="small"
            ref="xTable"
            :data="tableData_detable"
            align="center"
            header-align="center"
            :row-config="{ isCurrent: true, isHover: true }"
          >
            <!-- <vxe-column type="expand" width="40">
              <template #content="{ row }">
                <object
                  :data="'http://research.gzsys.org.cn/perturbdb/' + row.view"
                  width="100%"
                  height="500"
                ></object>
              </template>
            </vxe-column> -->
            <vxe-column field="hallmark" title="Phenotype" type="html">
              <template #default="{ row }">
                <!-- 做一个terms的外部超链接 -->
                {{ row.hallmark }}
              </template>
            </vxe-column>
            <!-- <vxe-column
              field="datasetid"
              title="Dataset ID"
              type="html"
            ></vxe-column> -->
            <!-- <vxe-column
              field="medianT"
              title="Median of non-targeting group"
              type="html"
            ></vxe-column>
            <vxe-column
              field="medianC"
              title="Median of perturbed group"
              type="html"
            ></vxe-column> -->
            <!-- <vxe-column
              field="rtype"
              title="Response type"
              type="html"
              :titlePrefix="{
                icon: 'vxe-icon-question-circle-fill',
                color: 'red',
                useHTML: true,
                message:
                  'Assessment of phenotypic reponse following genetic perturbation',
              }"
            >
              <template #default="{ row }">
      
                <a-tag v-if="row.rtype == 'inhibition'" color="#87d068">
                  Inhibition
                </a-tag>
                <a-tag v-else-if="row.rtype == 'activation'" color="#f50">
                  Activation
                </a-tag>
                <a-tag v-else>none</a-tag>
              </template></vxe-column
            > -->
            <vxe-column
              field="medianC"
              title="Median score of NT cells"
              type="html"
            >
              <template #default="{ row }">
                {{ Number.parseFloat(row.medianC).toPrecision(4) }}
              </template></vxe-column
            >
            <vxe-column
              field="medianT"
              title="Median score of perturbed cells"
              type="html"
            >
              <template #default="{ row }">
                {{ Number.parseFloat(row.medianT).toPrecision(4) }}
              </template></vxe-column
            >
            <vxe-column field="p" title="P-value" type="html">
              <template #default="{ row }">
                {{ Number.parseFloat(row.p).toPrecision(4) }}
              </template></vxe-column
            >
            <!-- <vxe-column field="p" title="Score" sortable type="html">
              <template #default="{ row }">
                <span v-if="row.vision == 'TRUE'">
                  <a-icon
                    style="font-size: 18px"
                    type="star"
                    theme="twoTone"
                    two-tone-color="#ffcc00"
                  />
                </span>
                <span v-if="row.Seurat == 'TRUE'">
                  <a-icon
                    style="font-size: 18px"
                    type="star"
                    theme="twoTone"
                    two-tone-color="#ffcc00"
                  />
                </span>
                <span v-if="row.aucell == 'TRUE'">
                  <a-icon
                    style="font-size: 18px"
                    type="star"
                    theme="twoTone"
                    two-tone-color="#ffcc00" /></span></template
            ></vxe-column> -->
            <!-- <vxe-column field="Seurat" title="AddModuleScore" type="html">
              <template #default="{ row }">
                <div
                  v-if="row.Seurat == 'TRUE'"
                  @click="showPDF(row.gene, row.datasetid, 'Seurat')"
                >
                  <a-button type="primary" size="small">PDF</a-button>
                </div>
                <div v-else>
                  <a-button type="primary" size="small" disabled>PDF</a-button>
                </div>
              </template></vxe-column
            > -->
            <vxe-column field="vision" title="View" type="html">
              <template #default="{ row }">
                <div @click="showPDF(row.gene, row.datasetId, row.pathway)">
                  <a-button type="primary" size="small">PDF</a-button>
                </div>
              </template>
            </vxe-column>
            <!-- <vxe-column field="aucell" title="AUCell" type="html">
              <template #default="{ row }">
                <div
                  v-if="row.aucell == 'TRUE'"
                  @click="showPDF(row.gene, row.datasetid, 'AUCell')"
                >
                  <a-button type="primary" size="small">PDF</a-button>
                </div>
                <div v-else>
                  <a-button type="primary" size="small" disabled>PDF</a-button>
                </div></template
              >
            </vxe-column> -->
            <template #empty>
              <span style="color: grey">
                No relevant phenotype was identified!
              </span>
            </template>
          </vxe-table>

          <vxe-pager
            background
            size="small"
            :loading="loading_detable"
            :current-page="tablePage_detable.currentPage"
            :page-size="tablePage_detable.pageSize"
            :total="tablePage_detable.totalResult"
            :page-sizes="[10, 20]"
            :layouts="[
              'PrevPage',
              'JumpNumber',
              'NextPage',
              // 'FullJump',
              'Sizes',
              'Total',
            ]"
            @page-change="handlePageChange_table"
          >
          </vxe-pager> </a-spin
      ></a-col>
    </a-row>
    <a-modal
      :visible="this.modal"
      :maskClosable="false"
      :keyboard="false"
      :closable="false"
      style="margin-top: 300px"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <div slot="title">Scoring based on {{ this.methods }} algorithm</div>
      <div slot="cancelText"><a-icon type="cloud-download" /> Download</div>
      <pdf ref="pdf" :src="this.url" />
    </a-modal>
  </div>
</template>

<script>
import axios from "axios";
import XEUtils from "xe-utils";
// import downloadexcel from "vue-json-excel";
import pdf from "vue-pdf";

export default {
  props: ["value"],
  components: {
    pdf,
  },
  data() {
    return {
      // 弹窗
      modal: false,
      url: "",
      methods: "",
      //加载
      spinning: true,
      //全表搜索
      filterName_detable: "",
      tempdata_detable: [],
      //分页
      getdata_detable: null, //必须要生成这个data
      loading_detable: false,
      tableData_detable: [],
      tablePage_detable: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 0,
      },
    };
  },
  created() {
    axios
      .get(
        "http://research.gzsys.org.cn/perturbdb/API/oncoPheno/search_genePheno.php",
        {
          params: {
            datasetID: this.$route.query.datasetId,
            gene: this.$route.query.gene,
          },
        }
      )
      .then((response) => {
        const convertedArray = response.data
          .filter((item) => item.medianT < item.medianC && item.p < 0.001)
          .sort((a, b) => a.p - b.p);
        this.getdata_detable = convertedArray;
        // this.tempdata_detable = convertedArray;
        this.findList_detable(this.getdata_detable);
      });
    this.spinning = false;
  },
  methods: {
    showPDF(value1, value2, value3) {
      this.modal = true;
      this.url =
        "http://research.gzsys.org.cn/perturbdb/data/publications/" +
        value2 +
        "/Hallmark/" +
        value3 +
        "/VISION/" +
        value1 +
        ".pdf";
      console.log(this.url);
    },
    changeData(value) {
      this.marker = value;
      this.getdata_detable = this.gsea[value];
      this.findList_detable(this.getdata_detable);
    },
    exportDataEvent() {
      if (this.tempdata_detable.length == 0) {
        const list = this.getdata_detable;
        this.$refs.xTable.exportData({
          filename: this.$route.query.gene + "_hallmark",
          type: "csv",
          isHeader: true,
          isFooter: true,
          data: list,
        });
      } else {
        const list = this.tempdata_detable;
        this.$refs.xTable.exportData({
          filename:
            this.$route.query.gene +
            "_hallmark-" +
            this.filterName_detable +
            "_related",
          type: "csv",
          isHeader: true,
          isFooter: true,
          data: list,
        });
      }
    },
    handleOk() {
      this.modal = false;
    },
    handleCancel() {
      // 创建一个隐藏的 <a> 元素
      var link = document.createElement("a");
      link.style.display = "none";

      // 设置文件的下载链接

      link.href = this.url;

      link.setAttribute(
        "download",
        this.methods + "_" + this.url.split("/").pop()
      );

      // 将 <a> 元素添加到文档中
      document.body.appendChild(link);

      // 模拟点击事件
      link.click();

      // 清理
      document.body.removeChild(link);
    },
    findList_detable(data) {
      this.loading_detable = true;
      setTimeout(() => {
        const list = data;
        this.loading_detable = false;
        this.tablePage_detable.totalResult = list.length;
        this.tableData_detable = list.slice(
          (this.tablePage_detable.currentPage - 1) *
            this.tablePage_detable.pageSize,
          this.tablePage_detable.currentPage * this.tablePage_detable.pageSize
        );
      }, 300);
    },
    handlePageChange_table({ currentPage, pageSize }) {
      this.tablePage_detable.currentPage = currentPage;
      this.tablePage_detable.pageSize = pageSize;
      if (this.tempdata_detable.length == 0) {
        this.findList_detable(this.getdata_detable);
      } else {
        this.findList_detable(this.tempdata_detable);
      }
    },
    searchEvent_detable() {
      this.tablePage_detable.currentPage = 1;
      const filterName = XEUtils.toValueString(this.filterName_detable)
        .trim()
        .toLowerCase();
      if (filterName != "" || filterName != " ") {
        const filterRE = new RegExp(filterName, "gi");
        const searchProps = ["hallmark", "rtype"];
        const rest = this.getdata_detable.filter((item) =>
          searchProps.some(
            (key) =>
              XEUtils.toValueString(item[key])
                .toLowerCase()
                .indexOf(filterName) > -1
          )
        );
        this.tempdata_detable = rest.map((row) => {
          const item = Object.assign({}, row);
          searchProps.forEach((key) => {
            item[key] = XEUtils.toValueString(item[key]).replace(
              filterRE,
              (match) => `${match}`
            );
          });
          return item;
        });
        this.findList_detable(this.tempdata_detable);
      } else {
        this.findList_detable(this.getdata_detable);
      }
    },
  },
};
</script>

<style></style>
